import { useState } from "react";
import "./FAQ.css";

const faq = [
  {
    q: "How does this site work?",
    a: "Watch this short video for a walkthrough of how IClimbTrees works and how to get the most out of it.",
    hasVideoLink: true,
  },
  {
    q: "Is this site free?",
    a: "It is for now and I'd like to keep it this way, but I also need a living income. If you can donate or know anyone who can help with sponsorship, then let me know. You should know from the start though that there's a chance that this site will be commercial one day with a subscription etc. However, I promise that any course you have started and made progress on will remain free forever.",
  },
  {
    q: "How can I support this site?",
    a: "The best way to support this site is to donate — every contribution helps keep it free for everyone.",
    linkHref: "https://ko-fi.com/simonprince",
    linkText: "Donate on Ko-fi",
  },
  {
    q: "Why don't you use more video?",
    a: "To learn difficult material, you must actively engage with it, and watching video is the most passive form of learning. Plus video has other disadvantages: it only runs at one speed, it's difficult to search, it's hard to edit and so hard to continuously improve.",
  },
  {
    q: "Why don't you mark the problems as right or wrong?",
    a: "What I really care about is that you try the problem. In a sense, you learn more if you get the question wrong than if you get them right. Anything that changes your current model of how things work is good for you.",
  },
  {
    q: "There's a problem with the website. How do I report it?",
    a: "You can mail me at iclimbtreesmail@gmail.com or (better) leave an issue at the GitHub repository.",
  },
];

export default function FAQ({ onOpenVideo }) {
  const [openIdx, setOpenIdx] = useState(null);

  const toggle = (i) => setOpenIdx((prev) => (prev === i ? null : i));

  return (
    <section id="faq" className="faq-section">
      <div className="container">
        <div className="faq-section__head">
          <span className="faq-section__eyebrow">Help</span>
          <h2 className="section-title">Frequently asked questions</h2>
          <p className="faq-section__sub">
            Everything you need to know about IClimbTrees.
          </p>
        </div>

        <dl className="faq-list">
          {faq.map((item, i) => (
            <div
              key={i}
              className={`faq-item${openIdx === i ? " faq-item--open" : ""}`}
            >
              <dt>
                <button
                  className="faq-item__question"
                  onClick={() => toggle(i)}
                  aria-expanded={openIdx === i}
                  aria-controls={`faq-answer-${i}`}
                  id={`faq-question-${i}`}
                >
                  <span>{item.q}</span>
                  <span className="faq-item__icon" aria-hidden="true">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                    >
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                  </span>
                </button>
              </dt>
              <dd
                id={`faq-answer-${i}`}
                className="faq-item__answer"
                role="region"
                aria-labelledby={`faq-question-${i}`}
              >
                <p>
                  {item.a}
                  {item.hasVideoLink && (
                    <>
                      {" "}
                      <button
                        type="button"
                        className="faq-section__link faq-item__video-link"
                        onClick={onOpenVideo}
                      >
                        Watch the video
                      </button>
                    </>
                  )}
                  {item.linkHref && (
                    <>
                      {" "}
                      <a
                        href={item.linkHref}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="faq-section__link"
                      >
                        {item.linkText}
                      </a>
                    </>
                  )}
                </p>
              </dd>
            </div>
          ))}
        </dl>

        <p className="faq-section__contact">
          Still have questions?{" "}
          <a
            href="mailto:iclimbtreesmail@gmail.com"
            className="faq-section__link"
          >
            Email us
          </a>{" "}
          or open an issue on{" "}
          <a
            href="https://github.com/udlbook/iclimbtrees"
            target="_blank"
            rel="noopener noreferrer"
            className="faq-section__link"
          >
            GitHub
          </a>
          .
        </p>
      </div>
    </section>
  );
}
